import { connect } from 'react-redux';
import { hasBalanceSheetEnabled } from 'state/user/selectors';
import BalanceSheetGrid from 'components/financials/balanceSheet/components/grid/BalanceSheetGrid';

/**
 * The concerns of this component is to determine if the balance sheet feature is enabled
 */
const mapState = (state) => ({
    isBalanceSheetEnabled: hasBalanceSheetEnabled(state),
    showDisabledView: true,
});

export default connect(mapState)(BalanceSheetGrid);
